import { LinearConnectionRouter } from './LinearConnectionRouter.js';

/**
 * A simple poly-linear routing which does not alter the intermediate points.
 * Does hold the underlying hit, bounds....logic.
 *
 * @type {*|Object|void|extend|Zepto.extend|b.extend}
 */
class PolylineRouter extends LinearConnectionRouter {
    constructor(connection) {
        super(connection);
        this.connection = connection;
    }
    route() {
        // just keep the points as is
    }
}

export { PolylineRouter };
